import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import {
    getWebsitePageUrl,
    getWebsitePageTitle,
    getCookieManageLabel,
} from '../../../../util/websiteLinks';

const LEGAL_PAGE_IDS = ['faq', 'terms', 'legal', 'contact'];

function FooterLegalLinks({ intl }) {
    const lang = intl.locale;

    return (
        <nav className="footer-legal" aria-label={getWebsitePageTitle('legal', lang) || 'Information'}>
            {LEGAL_PAGE_IDS.map(pageId => (
                <a
                    key={pageId}
                    href={getWebsitePageUrl(pageId, lang)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link-lux"
                >
                    {getWebsitePageTitle(pageId, lang)}
                </a>
            ))}
            <button type="button" className="footer-link-lux footer-legal__cookie-btn" data-mls-cookie-manage>
                {getCookieManageLabel(lang)}
            </button>
        </nav>
    );
}

FooterLegalLinks.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default injectIntl(FooterLegalLinks);
